/** Send an analytics event without allowing optional tracking to break the app. */
export function trackEvent(name, properties = {}) {
  try {
    const event = window.rybbit?.event;
    if (typeof event !== 'function') return;

    const result = event(name, properties);
    if (result && typeof result.catch === 'function') {
      result.catch(() => {});
    }
  } catch {
    // Analytics is optional and must never block portfolio interactions.
  }
}
